import { render, staticRenderFns } from "./customKanBan.vue?vue&type=template&id=6b853ac4&scoped=true&"
import script from "./customKanBan.vue?vue&type=script&lang=js&"
export * from "./customKanBan.vue?vue&type=script&lang=js&"
import style0 from "./customKanBan.vue?vue&type=style&index=0&id=6b853ac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b853ac4",
  null
  
)

export default component.exports